import PropTypes from 'prop-types';
import React from 'react';
import I18n from 'i18n-js';
import fatalErrorImage from 'public/images/fatal-error.svg';
import OverlayBody from '../overlay-body';
import styles from './styles.less';

const FatalError = ({
  onClose,
  imgSrc = fatalErrorImage,
  title = I18n.t('v2.error.home.fatalError.title'),
  description = I18n.t('v2.error.home.fatalError.description'),
  confirmButtonText = I18n.t('v2.error.home.fatalError.button'),
}) => (
  <OverlayBody
    showConfirm
    onConfirmClick={onClose}
    confirmButtonText={confirmButtonText}
    showHeader
    showClose
    showTitle={false}
    onClose={onClose}
    classnames={{
      overlayContent: styles.fatalErrorContent,
    }}
  >
    {imgSrc && <img src={imgSrc} alt="" className={styles.image} />}
    {title && <h1 className={styles.title}> {title} </h1>}
    {description && <p className={styles.description}> {description} </p>}
  </OverlayBody>
);

FatalError.defaultProps = {
  onClose: undefined,
  imgSrc: undefined,
  title: undefined,
  description: undefined,
  confirmButtonText: undefined,
};

FatalError.propTypes = {
  onClose: PropTypes.func,
  imgSrc: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  confirmButtonText: PropTypes.string,
};

export default FatalError;
